import { BucketedReward } from '../../models/paymentSubmissions';
import client from '../httpclient';

const getPaymentSubmissions = (): Promise<BucketedReward[]> => client
  .get(`/re/v1/bucket-reward`);

export default getPaymentSubmissions;
